exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Icon__icon{background:no-repeat 50%/contain;display:inline-block}", ""]);

// exports
exports.locals = {
	"icon": "Icon__icon"
};